import BasicRender from "./BasicRender";

/**
 *
 * Component renders a list of editable templates of type image
 */
const ImageRender = ({ imageTemplate, onRemove, isEditable }) => {
  return (
    <BasicRender
      datasetTemplate={imageTemplate}
      onRemove={onRemove}
      isEditable={isEditable}
    />
  );
};

export default ImageRender;
